import BasicList from '../BasicList';
import {get} from '../../utils/fetch';
import { backendServer } from '../../variable';

const requestList = async ({page, pageSize, ...params}) => {
  try {
    const result = await get(`${backendServer}/agentBuyBackOperating/query`, {
      page,
      pageSize,
      ...params
    });
    return result;
  } catch (e) {
    throw e;
  }
};

// 转让列表
const transferList = new BasicList(requestList);
transferList.setListName('转让列表');

export default transferList;



// WEBPACK FOOTER //
// ./src/stores/TransferList/index.js